import React, { useContext } from 'react';
import classNames from 'classnames';
import ResolveImage from 'components/ResolveImage';
import { useTranslation } from 'react-i18next';
import DataRoomEmptyImage from 'assets/images/data-room-empty-image.webp';
import { Button } from 'ncoded-component-library';
import CreateShareableLinkContext from 'router/subrouters/DataRoom/providers/CreateShareableLink/CreateShareableLink.context';

import './ShareableLinksEmpty.styles.scss';

type ShareableLinksEmptyProps = {
  className?: string;
};

const ShareableLinksEmpty: React.FC<ShareableLinksEmptyProps> = (props) => {
  const { className } = props;

  const classes = classNames('shareable-links-empty', 'white-panel', className);

  const { openCreateShareableLink } = useContext(CreateShareableLinkContext);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <ResolveImage
        src={DataRoomEmptyImage}
        asIllustration
        alt="No secure links yet."
      />

      <p>{t('noSecureSharesAvailableYet')}</p>

      <Button variant="outline" onClick={() => openCreateShareableLink()}>
        {t('createSecureLink')}
      </Button>
    </div>
  );
};

export default ShareableLinksEmpty;
